import DropItem from 'modules/expenses/components/common/DropItem'

interface Props {
  contentType: string
  createdAt: Date
  filename: string
  id: string
  size: number
  url: string
  status?: 'signed' | 'signing'
}

const FileDownloadCard = (file: Props) => {
  return (
    <DropItem
      key={file.id || file.filename}
      signedDocument={file.status === 'signed'}
      signingDocument={file.status === 'signing'}
      file={{
        id: file.id.toString(),
        name: file.filename,
        size: file.size.toString(),
        type: file.contentType,
        preview: file.url,
      }}
      downloadable
      showInViewer={false}
    />
  )
}

export default FileDownloadCard
